import { useEffect, useState } from "react";
import SideDrawerShell from "../../common/components/SideDrawerShell";
import { tasksApi } from "../api/tasksApi";
import "../../../V2SideDrawer.css";
import "../../common/styles/QuickViewDrawer.css";

function fmtDate(val) {
  if (!val) return "—";
  const d = new Date(val);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString();
}

export default function TaskQuickViewDrawer({ taskId, onClose }) {
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!taskId) return;
    let cancelled = false;
    setLoading(true);
    setError("");
    setTask(null);
    tasksApi.getById(taskId)
      .then((data) => { if (!cancelled) setTask(data); })
      .catch(() => { if (!cancelled) setError("Failed to load task details."); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [taskId]);

  return (
    <SideDrawerShell
      open={!!taskId}
      onClose={onClose}
      subtitle="TASK"
      title={task?.task_code || "Task"}
      width="min(560px, 100vw)"
      footer={task ? (
        <a className="qv-open-full" href={`/masterv2new?openTaskId=${task.id}`} target="_blank" rel="noreferrer">
          Open full view →
        </a>
      ) : null}
    >
      {loading && <div className="qv-state">Loading…</div>}
      {!loading && error && <div className="qv-state qv-state--error">{error}</div>}
      {!loading && !error && task && (
        <div className="qv-fields">
          <div className="qv-field qv-field--full">
            <span className="qv-label">Title</span>
            <span className="qv-value">{task.title || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Status</span>
            <span className="qv-value">{task.status || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Type</span>
            <span className="qv-value">{task.new_enhancement || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Customer</span>
            <span className="qv-value">{task.customer || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Project</span>
            <span className="qv-value">{task.project || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Feature</span>
            <span className="qv-value">{task.feature || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Sub-feature</span>
            <span className="qv-value">{task.sub_feature || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Assigned Member</span>
            <span className="qv-value">{task.tmm_member || "—"}</span>
          </div>
          <div className="qv-field">
            <span className="qv-label">Due Date</span>
            <span className="qv-value">{fmtDate(task.customer_due_date)}</span>
          </div>
          <div className="qv-field qv-field--full">
            <span className="qv-label">Description</span>
            <span className="qv-value qv-value--multiline">{task.description || "—"}</span>
          </div>
        </div>
      )}
    </SideDrawerShell>
  );
}
